module.exports = __webpack_public_path__ + "static/media/2.ad4eda61.svg";